import getCompoundMetricsRef from './getCompoundMetricsRef';
import getMetricCacheVersionRef from './getMetricCacheVersionRef';
import getNormalMetricsRef from './getNormalMetricsRef';

const metricDefinitions = {
  getCompoundMetricsRef,
  getMetricCacheVersionRef,
  getNormalMetricsRef,
};

export default metricDefinitions;
